<template>
    <div class="row">
        <div class="col">
            <div class="card card-form company-card">
                <div class="card-header insurance">
                    <div class="row">
                        <div class="col-12">
                            <div class="pull-left">
                                <span><i
                                        class="fa fa-list"></i> {{$t('company.workingPreciousMetalsStones.label')}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-8">
                            <div class="form-group">
                                <label>{{$t('company.field.dataNum')}}</label>
                                <input type="text" class="form-control"
                                       v-model="preciousMetalsStones.dataNum"
                                >
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.giveName')}}</label>
                                <textarea type="text" class="form-control"
                                          v-model="preciousMetalsStones.giveName"
                                ></textarea>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.startDate')}}</label>
                                <datepicker class="form-control" format="dd/MM/yyyy" v-model="startDate"
                                            :clear-button="false"
                                ></datepicker>
                            </div>
                            <div class="form-group">
                                <label>{{$t('company.field.endDate')}}</label>
                                <datepicker class="form-control" format="dd/MM/yyyy" v-model="endDate"
                                            :clear-button="false"
                                ></datepicker>
                            </div>
                        </div>
                        <drop-zone code="preciousMetalsStonesPicture"
                                   label="company.field.preciousMetalsStonesPicture"
                                   view="LOGO"
                                   folder="Company"
                                   subFolder="PreciousMetalsStones"
                                   :addRemoveLinks="hasCreate"
                                   :editable="hasCreate"
                                   :data="pictures"
                                   @change="(files) => {preciousMetalsStones.preciousMetalsStonesPictureFile = files[0]}"
                                   :maxFiles="1"
                                   acceptedFiles="image/*"
                        ></drop-zone>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-12">
                            <div class="text-right">
                                <router-link tag="button"
                                             class="all-btn ml-auto"
                                             v-if="!hasCreate && hasPermission('V2_COMPANY_ADD')"
                                             :to="{path: '/company/precious-metals-stones/add', query: {isCreate: true}}"
                                >
                                    <i class="fa fa-plus"></i>
                                    <span>{{$t('company.field.companyCreate')}}</span>
                                </router-link>
                                <button type="button"
                                        class="all-btn add-btn"
                                        v-else-if="hasCreate && hasPermission('V2_COMPANY_ADD')"
                                        @click="save"
                                        :disabled="processing"
                                >
                                    <i class="fa fa-check"></i>
                                    <span>{{$t('action.save')}}</span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import DropZone from '@/views/dropZone/DropZone'
    import Datepicker from 'vuejs-datepicker';
    import {formatDate, parseDate} from '@/shared/utils';

    export default {
        name: "WorkingPreciousMetalsStonesAddEdit",
        components: {
            DropZone,
            Datepicker
        },
        props: {
            data: Object
        },
        data() {
            return {
                processing: false,
                preciousMetalsStones: {
                    id: null,
                    dataNum: '',
                    giveName: '',
                    beginDate: null,
                    endDate: null,
                    preciousMetalsStonesPictureFile: {}
                },
                startDate: null,
                endDate: null,
                pictures: []
            }
        },
        computed: {
            hasCreate() {
                return this.$route.query.isCreate != null
            }
        },
        methods: {
            save() {

                this.processing = true;
                this.preciousMetalsStones.beginDate = formatDate(this.startDate);
                this.preciousMetalsStones.endDate = formatDate(this.endDate);

                this.$http.post('/company/precious-metals-stones', this.preciousMetalsStones)
                    .then(res => {
                        this.processing = false;
                        if (res.status === 200) {
                            this.$swal({
                                title: this.$t('messages.common.success'),
                                text: this.$t('messages.company.success'),
                                type: 'success'
                            });

                            this.$router.push('/company/profile')
                        }
                    }, () => {
                        this.$swal({
                            title: this.$t('messages.common.error'),
                            text: this.$t('messages.company.error'),
                            type: 'error'
                        });
                        this.processing = false;
                    });
            }
        },
        created() {

        },
        watch: {
            data: {
                immediate: true,
                handler(val) {
                    if (val) {
                        this.preciousMetalsStones = val;
                        this.startDate = parseDate(val.beginDate);
                        this.endDate = parseDate(val.endDate);
                        this.pictures.push(val.preciousMetalsStonesPictureFile);
                    }
                }
            }
        }
    }
</script>

<style scoped>
    .insurance {
        background-color: #2e7d32;
    }

    .card .card-header span {
        color: white;
        font-weight: bold;
        font-size: 15px;
    }

    .card .card-footer {
        background-color: #f2f2f2;
    }

</style>